import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaginationEmpty } from 'domain/models/queryPagination'
import { EventMovementsType } from 'domain/models/eventMovements'
import { ReadEventMovementsQueryResponse } from 'domain/entities/eventMovements'
import { RootState } from 'presentation/redux/reducers'

const initialState: EventMovementsType = {
  error: null,
  isLoading: false,
  eventMovements: [],
  paginationEventMovements: PaginationEmpty,
}

export const eventMovementsSlice = createSlice({
  name: 'eventMovements',
  initialState,
  reducers: {
    getEventMovementsStart: (state: EventMovementsType) => {
      state.isLoading = true
      state.error = null
    },
    getEventMovementsSuccess: (
      state: EventMovementsType,
      action: PayloadAction<ReadEventMovementsQueryResponse>,
    ) => {
      state.isLoading = false
      state.eventMovements = action.payload.entities
      state.paginationEventMovements = action.payload.pagination
    },
    getEventMovementsError: (state: EventMovementsType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const eventMovementsState = (state: RootState) => state.eventMovements
export const { getEventMovementsSuccess, getEventMovementsStart, getEventMovementsError } =
  eventMovementsSlice.actions

export default eventMovementsSlice.reducer
